import { render, staticRenderFns } from "./PlatformNewData.vue?vue&type=template&id=4e2719c4&scoped=true"
import script from "./PlatformNewData.vue?vue&type=script&lang=ts"
export * from "./PlatformNewData.vue?vue&type=script&lang=ts"
import style0 from "./PlatformNewData.vue?vue&type=style&index=0&id=4e2719c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2719c4",
  null
  
)

export default component.exports